import React from 'react'
import Chart from "react-apexcharts";

export default function PollResultGraph(props) {

    const { poll_data } = props

    // console.log(poll_data)

    var series = [{
        name: 'User',
        data: [poll_data && poll_data.count_a, poll_data && poll_data.count_b, poll_data && poll_data.count_c, poll_data && poll_data.count_d],
    },
        // {
        //     name: 'Pending',
        //     data: [76, 85, 100, 98]
        // }, {
        //     name: 'Processing',
        //     data: [35, 41, 36, 26]
        // }
    ]

    var options = {
        chart: {
            type: 'bar',
            // height: 350,

            toolbar: {
                show: false
            },

            zoom: {
                enabled: false
            },

            redrawOnParentResize: true,
            redrawOnWindowResize: true
        },
        plotOptions: {
            bar: {
                borderRadius: 3,
                horizontal: false,
                // columnWidth: '50%',
                endingShape: 'rounded'
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent'],
        },
        xaxis: {
            categories: [poll_data && poll_data.poll_option1, poll_data && poll_data.poll_option2, poll_data && poll_data.poll_option3, poll_data && poll_data.poll_option4],
        },
        yaxis: {
            min: 0,
            max: poll_data?.total_count,
            forceNiceScale: true
        },
        legend: {
            position: 'top',
            offsetY: 10
        },
        // yaxis: {
        //     title: {
        //         text: '$ (thousands)'
        //     }
        // },
        fill: {
            opacity: 1
        },
        // tooltip: {
        //     y: {
        //         formatter: function (val) {
        //             return "$ " + val + " thousands"
        //         }
        //     }
        // },
        colors: ["#2196f3"]
    }

    return (
        <>
            {/* <div className='dash_head d-flex justify-content-between'>
                <h5>Courses Overview</h5>
                <select className="form-select form_input" aria-label="Default select example" style={{ width: '200px' }}>
                    <option value=''>Options</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                </select>
            </div> */}
            <Chart options={options} series={series} type="bar" height='240px' width='100%' />
        </>
    )
}
